module.exports = __webpack_public_path__ + "static/media/girl.d488516b.svg";